import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getDashboardStats } from '../services/dashboardService';
import { useAuth } from '../context/AuthContext';

const CARDS = [
  // section, key, label, icon, route (null = no link)
  ['Overview', 'totalOrders',        'Total Orders',            'fas fa-receipt',          '/orders'],
  ['Overview', 'vendors',            'Total Vendors',           'fas fa-store',             '/registerlist'],
  ['Overview', 'items',              'Total Items',             'fas fa-boxes',             null],
  ['Overview', 'codAmount',          'COD Amount',              'fas fa-money-bill-wave',   '/orders'],
  ['Overview', 'onlinePayment',      'Online Payments',         'fas fa-credit-card',       '/orders'],

  ["Today's Activity", 'todayOrders',        "Today's Orders",          'fas fa-calendar-day',     '/orders'],
  ["Today's Activity", 'incompleteOrders',   'Incomplete Orders',       'fas fa-exclamation-circle','/orders'],
  ["Today's Activity", 'todayCodOrders',     'Today COD Orders',        'fas fa-money-bill',       '/orders'],
  ["Today's Activity", 'todayOnlinePayment', 'Today Online Orders',     'fas fa-wallet',           '/orders'],
  ["Today's Activity", 'users',              'New Users Today',         'fas fa-user-plus',        '/users'],
  ["Today's Activity", 'cashCollection',     'Cash Collection',         'fas fa-hand-holding-usd', '/orders'],

  ['Complaints', 'totalComplaints',   'Total Complaints',        'fas fa-comment-dots',     null],
  ['Complaints', 'solvedComplaints',  'Solved',                  'fas fa-check-circle',     null],
  ['Complaints', 'pendingComplaints', 'Pending',                 'fas fa-clock',            null],

  ['Order Schedule', 'todaysOrders',   "Today's Scheduled",       'fas fa-calendar-check',  '/orders'],
  ['Order Schedule', 'tomorrowOrders', "Tomorrow's Scheduled",    'fas fa-calendar-alt',    '/orders'],
];

const SECTIONS = ['Overview', "Today's Activity", 'Complaints', 'Order Schedule'];

const StatCard = ({ card, value, onClick }) => {
  const [, key, label, icon, route] = card;
  const hasLink = !!route;
  return (
    <div
      className={`stat-card${hasLink ? '' : ' no-link'}`}
      onClick={() => hasLink && onClick(route)}
      title={hasLink ? `View ${label}` : ''}
    >
      <div className="stat-top">
        <div className="stat-icon"><i className={icon} /></div>
        {hasLink && <span className="stat-arrow">›</span>}
      </div>
      <div>
        <div className="stat-val">{value ?? 0}</div>
        <div className="stat-lbl">{label}</div>
        {hasLink && <div className="stat-hint">View details →</div>}
      </div>
    </div>
  );
};

const Dashboard = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [stats,   setStats]   = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  useEffect(() => {
    getDashboardStats()
      .then(data => { setStats(data); setLoading(false); })
      .catch(() => {
        setStats({
          totalOrders: 0, vendors: 0, items: 0, codAmount: 0, onlinePayment: 0,
          todayOrders: 0, incompleteOrders: 0, todayCodOrders: 0, todayOnlinePayment: 0,
          users: 0, cashCollection: 0, totalComplaints: 0, solvedComplaints: 0,
          pendingComplaints: 0, todaysOrders: 0, tomorrowOrders: 0, AdminCreate: 0,
        });
        setLoading(false);
      });
  }, []);

  const date = new Date().toLocaleDateString('en-IN', {
    weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
  });

  const allCards = currentUser?.isSuperAdmin
    ? [...CARDS, ['Overview', 'AdminCreate', 'Admins Created', 'fas fa-user-shield', '/create']]
    : CARDS;

  if (loading) return (
    <div className="dash-loading">
      <div className="spinner" />
      <p>Loading dashboard…</p>
    </div>
  );

  if (error) return <div className="dash-error">{error}</div>;

  return (
    <div className="dashboard">
      {/* Welcome strip */}
      <div className="dash-welcome">
        <div className="dash-welcome-left">
          <h2>Welcome back, {currentUser?.name || 'Admin'}</h2>
          <p>{currentUser?.isSuperAdmin ? 'Super Admin' : 'Admin'} · Overview of your platform</p>
        </div>
        <span className="dash-welcome-date">{date}</span>
      </div>

      {/* Sections */}
      {SECTIONS.map(section => {
        const group = allCards.filter(c => c[0] === section);
        if (!group.length) return null;
        return (
          <div key={section}>
            <div className="dash-label">{section}</div>
            <div className="stat-grid">
              {group.map(card => (
                <StatCard
                  key={card[1]}
                  card={card}
                  value={stats?.[card[1]]}
                  onClick={navigate}
                />
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Dashboard;
